module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE3SURBVHgBrVSBccIwDPxwHSAjeARGyAZlBDpB2wmSTtB2glwnSDcInSBlgsAEsIGRjveRC3EsOP7uz3FOesmyLCAC730uLIWd8EC2wjXuhTgXFPIUq4RfDKLohe4WTRV1dO6mnDVjBlXx3KoLOsw68USKCkbR4LA22LbMfDKBxWi/5PqLNH6EKuoswvaaJXzGwjuuS6QRbP6TluxdrVtjsNML7mAFe1ZRzog2tClgBR3DQ6iFK/a28o2Z2lttRnwKTUojmxB9laXC+bb1Yv5wuVQnfOaq/16yLNvQx8n3OyKZ1oP5UCB+ooIlablX+z5mXN5au/DqosL+MnhqGMFEejJMwrD/fKJdaK0P2LEVbvi9Eh4H+32IrhEt8yGW/VUpFvJDn2Y+iPYQaCl2OJfg7owF3xgNoxNvt4hVBeX+1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mUser.png
// module id = KcBO
// module chunks = 1